module.exports = __webpack_public_path__ + "img/sequence-miyashita-park-sp@2x.eb726b60.jpg";